var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "exam-entrance-container" }, [
    _c(
      "div",
      { staticClass: "exam-header" },
      [
        _c(
          "el-row",
          { attrs: { type: "flex", justify: "space-between" } },
          [
            _c("el-col", { staticClass: "exam-title", attrs: { span: 8 } }, [
              _c("h3"),
            ]),
            _c("el-col", { attrs: { span: 8 } }, [
              _c("div", { staticClass: "goback" }),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "exam-entrance-main" }, [
      _c("div", { staticClass: "exam-entrance-wrapper" }, [
        _c("div", { staticClass: "examinfo-content" }, [
          _c("div", { staticClass: "left" }, [
            _c("div", { staticClass: "icon-svg exam" }, [
              _vm.types === "exam"
                ? _c("img", {
                    staticClass: "icon",
                    attrs: { src: "/static/img/icon_ks.png" },
                  })
                : _c("img", {
                    staticClass: "icon",
                    attrs: { src: "/static/img/icon_lx.png" },
                  }),
            ]),
          ]),
          _c("div", { staticClass: "right" }, [
            _c("p", { staticClass: "sub" }, [
              _c("span", [_vm._v(_vm._s(_vm.examInfo.name))]),
            ]),
            _c("div", { staticClass: "operate" }, [
              _vm.examInfo.examDateTime && _vm.types == "exam"
                ? _c("span", { staticClass: "time" }, [
                    _vm._v(_vm._s(_vm.examInfo.examDateTime) + " "),
                  ])
                : _vm._e(),
              _vm.examInfo.examTime
                ? _c("span", { staticClass: "time" }, [
                    _vm._v(
                      _vm._s(_vm.examInfo.examTime) +
                        _vm._s(_vm.types == "exam" ? "分钟" : "")
                    ),
                  ])
                : _vm._e(),
            ]),
            _c(
              "div",
              { staticClass: "count" },
              [
                _vm._l(_vm.sortList, function (li) {
                  return [
                    _c("div", { key: li.text, staticClass: "item" }, [
                      _c("span", { staticClass: "tips" }, [
                        _vm._v(
                          _vm._s(li.text == "总题数" ? "练习总题" : li.text)
                        ),
                      ]),
                      _c("span", { staticClass: "total" }, [
                        _vm._v(" " + _vm._s(li.value)),
                        _c("span", { staticClass: "unit" }, [
                          _vm._v(_vm._s(li.unit)),
                        ]),
                      ]),
                    ]),
                  ]
                }),
              ],
              2
            ),
            _vm.examInfo.batchId && _vm.types === "exam"
              ? _c(
                  "div",
                  { staticClass: "btns" },
                  [
                    _c(
                      "dsf-button",
                      {
                        attrs: {
                          size: "small",
                          type: "plain",
                          title: "考生须知",
                        },
                        on: { click: _vm.getRules },
                      },
                      [_vm._v(" 考生须知 ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "user-form" },
          [
            _c(
              "el-form",
              {
                ref: "loginform",
                attrs: {
                  model: _vm.form,
                  "label-width": "100px",
                  size: "small",
                },
              },
              [
                _vm._l(_vm.sortReserved, function (item, index) {
                  return [
                    _c("UserFormItem", {
                      key: item.fields_value,
                      attrs: {
                        modelvalue: _vm.form[item.fields_value],
                        rules: _vm.rules[item.fields_value],
                        formItem: item,
                        itemIndex: index,
                        sexSetting: _vm.sexSetting,
                        hasphoto: _vm.hasphoto,
                      },
                      on: { "set-value": _vm.setValue },
                    }),
                  ]
                }),
                _vm.reserved.length > 0
                  ? _c("el-form-item", [
                      _c(
                        "div",
                        { staticClass: "button-nav" },
                        [
                          _c(
                            "dsf-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.submitForm("loginform")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "进入" +
                                  _vm._s(_vm.types == "exam" ? "考试" : "练习")
                              ),
                            ]
                          ),
                          _c(
                            "dsf-button",
                            {
                              staticClass: "ds-button plain",
                              on: {
                                click: function ($event) {
                                  return _vm.resetForm("loginform")
                                },
                              },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }